import service from './index'

const getResource = service.resource('quote-day/quote-of-the-day/{date}')
const createResource = service.resource('quote-day/create')
const updateResource = service.resource('quote-day/update')

export default {
  createOne (quote) {
    return createResource.save({}, quote)
  },
  updateOne (quote) {
    return updateResource.update({}, quote)
  },
  getOne (date){
    return getResource.get({date:date})
  }
}




// WEBPACK FOOTER //
// ./src/services/raceQuote.js